import DashboardChart from "../DashboardChart/DashboardChart";
import DashboardChartNumbers from "../DashboardChart/DashboardChartNumbers";
import { useGetAllDevicesStatusQuery } from "../../../../Redux/service/Alerts/Alerts";
import trans from "../../../../utils";

export default function DashboardVehicle() {
  const { data, isLoading, isError } = useGetAllDevicesStatusQuery();

  return (
    <>
      <div className="bg-white-rounded p-4">
        <p className="fs-16 fw-600 neutral-500 mb-3">
          {trans("Vehicle Status")}
        </p>
        <div className="flex-between">
          <div className="mt-3">
            <span className="fs-14 fw-500 neutral-500">
              Number of Total Vehicles
            </span>
            <p className="fs-24 fw-600 neutral-800 mt-2">
              {isLoading
                ? "Loading..."
                : isError
                ? "Error loading data"
                : data?.data?.totalDevices ?? "N/A"}
            </p>
          </div>
          <div>
            <DashboardChart
              data={data}
              isLoading={isLoading}
              isError={isError}
            />
          </div>
        </div>
        <DashboardChartNumbers
          data={data}
          isLoading={isLoading}
          isError={isError}
        />
      </div>
    </>
  );
}
